import router from '@/router';
import Auth from '@/services/Auth';

router.beforeEach(async (to, from, next) => {
     // Redirect to the login page if not authenticated
     if (to.meta && to.meta.permission !== undefined) {
          if (Auth.checkPermission(to.meta.permission)) {
               next();
          } else {
               router.push({
                    name: 'home',
               });
          }
     } else {
          next();
     }
});
